import script from "./AuthSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthSection.vue?vue&type=script&lang=ts&setup=true"

import "./AuthSection.vue?vue&type=style&index=0&id=3523fc27&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3523fc27"]])

export default __exports__